import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToTimelineTap = (
    timelineTap$: Observable<number>,
    playbackStore: IPlaybackStore
): Subscription =>
    timelineTap$
        .subscribe(seekTime => playbackStore.actions.updateCurrentTime(seekTime));

export default subscribeToTimelineTap;